import { getDealerBasePath } from "./getDealerBasePath";

export type DealerLink = {
  isActive: boolean;
  name: string;
  to: string;
};

export const createDealerLink = (
  name: string,
  segment: string,
  options?: { exact?: boolean; strictCase?: boolean }
): DealerLink => {
  const { exact = false, strictCase = false } = options || {};
  const base = getDealerBasePath();
  const url = segment.startsWith("#") ? segment : `${base}/${segment}`;
  const { pathname } = window.location;
  const comparePath = strictCase ? pathname.toLowerCase() : pathname;
  const compareUrl = strictCase ? url.toLowerCase() : url;
  return {
    isActive: exact
      ? comparePath.replace(/\/$/, "") === compareUrl.replace(/\/$/, "")
      : comparePath.startsWith(compareUrl),
    name,
    to: url,
  };
};
